import { render, staticRenderFns } from "./seasonSchedulesList.vue?vue&type=template&id=63b73b65&scoped=true"
import script from "./seasonSchedulesList.vue?vue&type=script&lang=js"
export * from "./seasonSchedulesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b73b65",
  null
  
)

export default component.exports